/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gallery_ReportInputs */

const en_us2_gallery_report = /** @type {(inputs: Gallery_ReportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Report`)
};

const pt_br2_gallery_report = /** @type {(inputs: Gallery_ReportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Denunciar`)
};

const pt_pt2_gallery_report = /** @type {(inputs: Gallery_ReportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Denunciar`)
};

/** @type {(inputs: Gallery_ReportInputs) => LocalizedString} */
const es_419_gallery_report = en_us2_gallery_report;

/** @type {(inputs: Gallery_ReportInputs) => LocalizedString} */
const fr_fr2_gallery_report = en_us2_gallery_report;

/** @type {(inputs: Gallery_ReportInputs) => LocalizedString} */
const de_de2_gallery_report = en_us2_gallery_report;

/** @type {(inputs: Gallery_ReportInputs) => LocalizedString} */
const it_it2_gallery_report = en_us2_gallery_report;

/**
* | output |
* | --- |
* | "Report" |
*
* @param {Gallery_ReportInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const gallery_report = /** @type {((inputs?: Gallery_ReportInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gallery_ReportInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_gallery_report(inputs)
	if (locale === "es-419") return es_419_gallery_report(inputs)
	if (locale === "pt-PT") return pt_pt2_gallery_report(inputs)
	if (locale === "fr-FR") return fr_fr2_gallery_report(inputs)
	if (locale === "de-DE") return de_de2_gallery_report(inputs)
	if (locale === "it-IT") return it_it2_gallery_report(inputs)
	return en_us2_gallery_report(inputs)
});
export { gallery_report as "gallery.report" }